import { ArticuloContact } from "./ArticuloContact";
//Objeto que usaremos para guardar la hoja
export class Hoja
{
    public siniestro: string = "";
    public piloto: string = "";
    public origen: string = "";
    public tipocall: string = "";
    public numcli: string = "";
    public taller: number = 0;
    public dni: string = "";
    public poliza: string = "";
    public nombreCli: string = "";
    public telfCli: string = "";
    public telfCli2: string = "";
    public entidad: number = 0;
    public emailCli: string = "";
    private matricula: string = "";
    public marca: string = "";
    public modelo: string = "";
    public quien: string = "";
    public usuario: string = "";
    public ivaAsegurado: string = "";
    public par11: string = "";
    public agente: string = "";
    public km: number = 0;
    public fecsin: Date | string = "";
    public fecha: Date | string = "";
    public fec_cita: Date | string | null = null;
    public hora_cita: string = "";
    public color: string = "";
    public bastidor: string = "";
    public obser: string = "";
    public suslloc: string = "";
    public articulos: ArticuloContact[] | null = [];
    public parmov: string = "";
    public servicio: string = "";
    public umCalibra: string = "";
    public estadoPresupuesto: string = "";
    public sucdesc: string = "";
    public suc_detalle: string = "";
    public desservicio: string = "";
    public peticion: string = "";
    public artcontact2: string = "";
    public idtrans: number = 0;
    public campa: string = "";
    public dirrecogida: string = "";
    public pobrecogida: string = "";
    public cprecogida: string = "";
    public idcorredor: number = 0;
    public idlinea: number  = 0;
    public idservicios: number = 0;
    public idgestionweb: number = 0;
    public idAlphabet: number = 0;
    public serviciorecogida: string = "";
    public articulorecogida: string = "";
    public descrecogida: string = "";
    public eurorecodiga: string = "";
    public dirCli: string = "";
    public caseId: string = "";
    public pickup: string = "";
    
    constructor(siniestro: string , piloto: string , origen: string , tipocall: string , numcli: string , taller: number , 
        dni: string , poliza: string , nombreCli: string , telfCli: string , telfCli2: string , entidad: number , emailCli: string , 
        matricula: string , marca: string , modelo: string , quien: string , usuario: string , ivaAsegurado: string , par11: string , 
        agente: string , km: number , fecsin: Date , fecha: Date , color: string , bastidor: string , obser: string , suslloc: string , 
        articulos: ArticuloContact[] , parmov: string , servicio: string , umCalibra: string , estadoPresupuesto: string , sucdesc: string ,suc_detalle: string , 
        desservicio: string , peticion: string , artcontact2: string , idtrans: number , campa: string , dirrecogida: string , pobrecogida: string , 
        cprecogida: string , idcorredor: number , idlinea: number , idservicios: number , idgestionweb: number , idAlphabet: number , serviciorecogida: string ,
         articulorecogida: string , descrecogida: string , eurorecodiga: string, dirCli: string, caseId:string, fec_cita: Date|null, hora_cita: string, pickup: string)
    {
		this.siniestro = siniestro;
		this.piloto = piloto;
		this.origen = origen;
		this.tipocall = tipocall;
		this.numcli = numcli;
		this.taller = taller;
		this.dni = dni;
		this.poliza = poliza;
		this.nombreCli = nombreCli;
		this.telfCli = telfCli;
		this.telfCli2 = telfCli2;
		this.entidad = entidad;
		this.emailCli = emailCli;
		this.matricula = matricula;
		this.marca = marca;
		this.modelo = modelo;
		this.quien = quien;
		this.usuario = usuario;
		this.ivaAsegurado = ivaAsegurado;
		this.par11 = par11;
		this.agente = agente;
		this.km = km;
		this.fecsin = fecsin;
		this.fecha = fecha;
		this.color = color;
		this.bastidor = bastidor;
		this.obser = obser;
		this.suslloc = suslloc;
		this.articulos = articulos;
		this.parmov = parmov;
		this.servicio = servicio;
		this.umCalibra = umCalibra;
		this.estadoPresupuesto = estadoPresupuesto;
		this.sucdesc = sucdesc;
        this.suc_detalle = suc_detalle;
		this.desservicio = desservicio;
		this.peticion = peticion;
		this.artcontact2 = artcontact2;
		this.idtrans = idtrans;
		this.campa = campa;
		this.dirrecogida = dirrecogida;
		this.pobrecogida = pobrecogida;
		this.cprecogida = cprecogida;
		this.idcorredor = idcorredor;
		this.idlinea = idlinea;
		this.idservicios = idservicios;
		this.idgestionweb = idgestionweb;
		this.idAlphabet = idAlphabet;
		this.serviciorecogida = serviciorecogida;
		this.articulorecogida = articulorecogida;
		this.descrecogida = descrecogida;
		this.eurorecodiga = eurorecodiga;
        this.dirCli = dirCli;
        this.caseId = caseId;
        this.fec_cita = fec_cita;
        this.hora_cita = hora_cita;
        this.pickup = pickup;
	}

    //devuelve una instacia de hoja con los valores por defecto
    //Se tendrán que ir rellenando mas adelante
    public static hojaVacia(): Hoja
    {
        return new Hoja
        (
            "", // siniestro
            "", // piloto
            "", // origen
            "", // tipocall
            "", // numcli
            0,  // taller
            "", // dni
            "", // poliza
            "", // nombreCli
            "", // telfCli
            "", // telfCli2
            0,  // entidad
            "", // emailCli
            "", // matricula
            "", // marca
            "", // modelo
            "", // quien
            "", // usuario
            "", // ivaAsegurado
            "", // par11
            "", // agente
            0,  // km
            new Date(), // fecsin - podría ser también null si se maneja adecuadamente
            new Date(), // fecha - podría ser también null si se maneja adecuadamente
            "", // color
            "", // bastidor
            "", // obser
            "", // suslloc
            [], // articulos
            "", // parmov
            "", // servicio
            "", // umCalibra
            "", // estadoPresupuesto
            "", // sucdesc
            "", // sucdesc
            "", // desservicio
            "", // peticion
            "", // artcontact2
            0,  // idtrans
            "", // campa
            "", // dirrecogida
            "", // pobrecogida
            "", // cprecogida
            0,  // idcorredor - podría ser también null si se maneja adecuadamente
            0,  // idlinea - podría ser también null si se maneja adecuadamente
            0,  // idservicios - podría ser también null si se maneja adecuadamente
            0,  // idgestionweb - podría ser también null si se maneja adecuadamente
            0,  // idAlphabet - podría ser también null si se maneja adecuadamente
            "", // serviciorecogida
            "", // articulorecogida
            "", // descrecogida
            "", // eurorecodiga
            "", //direccion del cliente
            "",
            null, // fec_cita - podría ser también null si se maneja adecuadamente
            "", // hora_cita
            ""  // pickup
        );
    }


    /**
     * Getter $matricula
     * @return {string }
     */
	public getMatricula(): string  {return this.matricula;}

    public extranjera: boolean = false; 
    public set $matricula(value: string)
    {
        value = value?.toUpperCase().trim();

        const regex = new RegExp(
        '^(?:[0-9]{4}[A-Z]{3})|(?:[A-Z]{1}[0-9]{4}[A-Z]{2})|(?:[A-Z]{2}-[0-9]{4}-[A-Z]{1})|(?:[A-Z]{2}-[0-9]{5})|(?:E [0-9]{4} [A-Z]{3})|(?:[A-Z]{4}[0-9]{4}[A-Z]{1})|(?:[A-Z]{3}[0-9]{4}[A-Z]{1})|(?:[A-Z]{2}[0-9]{6})|(?:C[0-9]{4}[B-Z]{3})|(?:E[.·][0-9]{4})|(?:[E-Z][A-Z][0-9]{4}[A-Z]{1})|(?:[CGPC][0-9]{4}[A-Z]{1})$',
        'i'
        );

        if (this.extranjera) {
            this.matricula = value;
        } else {
            this.matricula = regex.test(value) ? value : "";
        }

        console.info("La matricula de Hoja es :" + this.matricula);
    }

}
